import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import * as styles from "./Recent.module.scss"

const Recent = () => {
  const data = useStaticQuery(graphql`
    query {
      imageFeatured1: file(relativePath: { eq: "profile_featured_bbd.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageFeatured2: file(
        relativePath: { eq: "profile_featured_instruments.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageFeatured3: file(relativePath: { eq: "profile_featured_afa.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  const imageFeatured1 = data.imageFeatured1.childImageSharp.fluid
  const imageFeatured2 = data.imageFeatured2.childImageSharp.fluid
  const imageFeatured3 = data.imageFeatured3.childImageSharp.fluid

  return (
    <div className={styles.root}>
      <div className={`${styles.recent} recent`}>
        <div className="container-wide">
          <h3 className={styles.recent__head}>Recent works</h3>

          <div className={styles.featured}>
            <div className={styles.featured__item}>
              <div className={styles.featured__image}>
                <Img fluid={imageFeatured1} alt="" />
              </div>
              <div className={styles.featured__text}>
                <p>
                  Fumiro served as the colorist for the documentary Black Box
                  Diaries, directed by Shiori Ito. The film has been nominated
                  for an Oscar for Best Feature Documentary and has won a
                  Peabody Award.
                </p>
              </div>
            </div>

            <div className={styles.featured__item}>
              <div className={styles.featured__image}>
                <Img fluid={imageFeatured2} alt="" />
              </div>
              <div className={styles.featured__text}>
                <p>
                  Fumiro also color graded the documentary Instruments of a
                  Beating Heart, directed by Ema Ryan Yamazaki. This film has
                  been nominated for an Oscar for Best Short Documentary.
                </p>
              </div>
            </div>

            <div className={styles.featured__item}>
              <div className={styles.featured__image}>
                <Img fluid={imageFeatured3} alt="" />
              </div>
              <div className={styles.featured__text}>
                <p>
                  Fumiro and his collaborator, Houdini FX artist Kobari
                  Yasuhiro, received a nomination for the Best Visual Effects
                  for the Asian Film Award for the fiction feature film Black
                  Ox.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Recent
